module.exports = __webpack_public_path__ + "img/TEMPERATURE.f01f0e9f.png";